import {UscType} from './../../../models/profile/uscType';
import {GetHolderProfileCabinetResponsePayload} from '../../../models/api';
import {startDigits} from '../../../constants';

export default {
  firstName: 'Максим',
  lastName: 'Кайгородцев',
  middleName: 'Игоревич',
  birthDate: '1984-10-02',
  sex: 0,
  snils: '48750603815',
  usc: `${startDigits}112960209587`,
  dateIssue: '2020-03-01',
  mobilePhone: '9061478529',
  email: '',
  address: '620137, Свердловская обл, г Екатеринбург, Кировский р-н, ул Советская, д 62, кв 66',
  uscType: UscType.Financial,
  uscIsBlocked: false,
  campusParticipant: false,
} as GetHolderProfileCabinetResponsePayload;
